/**
 * StatChip — small label+value pill used in study page stat rows
 * (WPM / ACC / ERR etc).
 */
interface Props {
  label: string;
  value: string;
  tone: 'cyan' | 'lime' | 'pink' | 'cream';
}

const TONE_CLASS: Record<Props['tone'], string> = {
  cyan:  'text-honey-300 border-honey-400/40',
  lime:  'text-mint-300 border-mint-400/40',
  pink:  'text-ember-300 border-ember-400/40',
  cream: 'text-cream-200 border-white/[0.1]',
};

export function StatChip({ label, value, tone }: Props): JSX.Element {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-md bg-ink-900/60 border px-2.5 py-1 ${TONE_CLASS[tone]}`}>
      <span className="text-cream-400 tracking-widest text-[10px]">{label}</span>
      <span className="font-bold font-mono tracking-tight">{value}</span>
    </span>
  );
}
